import React, { FC, useCallback } from "react"
import { observer } from "mobx-react-lite"
import { Appearance, Linking, useColorScheme, ViewStyle } from "react-native"
import { Button, Image, JalaIcon, Screen, Text } from "../../../components"
import { color } from "../../../theme"
import { CompositeScreenProps } from "@react-navigation/native"
import { Icon, ScrollView, View } from "native-base"
import { translate } from "../../../i18n"
import Ionicons from "react-native-vector-icons/Ionicons"
import { push } from "../../../navigators"
import config from "../../../utils/config"

const ROOT: ViewStyle = {
  backgroundColor: color.palette.backgroundGray,
  flex: 1,
}

const IMAGE_JALA_PRO = require("./photo-jala-pro.png")

const { BASE_URL } = config();

export const GotoJalaProScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function GotoJalaProScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() , navigation } = props

  const onPressInfo = useCallback(() => {
    Linking.openURL('https://jala.tech/pro').catch();
  },[])
  
  const onPressGotoPayment = useCallback(() => {
    navigation.goBack()
    push('Home.Stack', {
      screen: 'Home.JalaWebView',
      params: {
        uri: `${BASE_URL}/web_view/subscriptions`,
        title: translate("gotoJalaProScreen.upgrade"),
        backgroundColor: color.palette.backgroundGray }
    });
  },[])

  return (
    <Screen style={ROOT} colorScheme={colorScheme}>
      <View
        background={"#002147"}
        height={"260px"}
      >
        <Image
          source={IMAGE_JALA_PRO}
          style={{
            width: 269,
            height: 205,
            position: 'absolute',
            bottom: 9, left: 15,
          }}
          resizeMode="contain"
        />
        <Icon
          as={<JalaIcon name={"close"} />} size={"24px"} color={color.palette.white}
          onPress={() => navigation.goBack()} top={"35px"} left={"20px"} position={"absolute"}
        />
        <View
          style={{
            backgroundColor: color.palette.white,
            position: 'absolute', height: 31,
            bottom: 12, right: 27, flexDirection: 'row',
            justifyContent: 'center', alignItems: 'center',
            borderRadius: 5, paddingHorizontal: 8
          }}
        >
          <Icon
            as={<JalaIcon name={"premium-1"} />} size={"24px"} color={color.palette.orange500}
            onPress={() => navigation.goBack()}
          />
          <Text paddingLeft="5px" marginTop={"-3px"} preset="title4" tx="gotoJalaProScreen.buttonText" colorScheme={colorScheme} />
        </View>
      </View>
      <ScrollView paddingTop={"18px"} paddingX={"16px"}>
        <Text preset="display1" color={"#002147"}>{translate("gotoJalaProScreen.title")}
          <Text preset="display1" color={color.palette.blue500} tx="gotoJalaProScreen.buttonText" colorScheme={colorScheme} />
          <Icon as={<JalaIcon name={"premium-1"} />} color={color.palette.orange500} />
        </Text>
        <Text paddingTop="10px" preset="body3" tx="gotoJalaProScreen.description" colorScheme={colorScheme} />
        <View flexDirection={"row"} marginTop={"10px"}>
          <Icon
            as={<Ionicons name={"checkmark-circle"} />} size={"16px"} color={color.palette.blueJalaBase}
            marginTop={"5px"}
          />
          <View flex={1} paddingLeft={"12px"}>
            <Text tx="gotoJalaProScreen.benefitTitle1" preset="title3" colorScheme={colorScheme} />
            <Text tx="gotoJalaProScreen.benefitDesc1" preset="body3" colorScheme={colorScheme} />
          </View>
        </View>
        <View flexDirection={"row"} marginTop={"10px"}>
          <Icon
            as={<Ionicons name={"checkmark-circle"} />} size={"16px"} color={color.palette.blueJalaBase}
            marginTop={"5px"}
          />
          <View flex={1} paddingLeft={"12px"}>
            <Text tx="gotoJalaProScreen.benefitTitle2" preset="title3" colorScheme={colorScheme} />
            <Text tx="gotoJalaProScreen.benefitDesc2" preset="body3" colorScheme={colorScheme} />
          </View>
        </View>
        <View flexDirection={"row"} marginTop={"10px"}>
          <Icon
            as={<Ionicons name={"checkmark-circle"} />} size={"16px"} color={color.palette.blueJalaBase}
            marginTop={"5px"}
          />
          <View flex={1} paddingLeft={"12px"}>
            <Text tx="gotoJalaProScreen.benefitTitle3" preset="title3" colorScheme={colorScheme} />
            <Text tx="gotoJalaProScreen.benefitDesc3" preset="body3" colorScheme={colorScheme} />
          </View>
        </View>
        <View flexDirection={"row"} marginTop={"10px"}>
          <Icon
            as={<Ionicons name={"checkmark-circle"} />} size={"16px"} color={color.palette.blueJalaBase}
            marginTop={"5px"}
          />
          <View flex={1} paddingLeft={"12px"}>
            <Text tx="gotoJalaProScreen.benefitTitle4" preset="title3" colorScheme={colorScheme} />
            <Text tx="gotoJalaProScreen.benefitDesc4" preset="body3" colorScheme={colorScheme} />
          </View>
        </View>
        <View flexDirection={"row"} marginTop={"10px"}>
          <Icon
            as={<Ionicons name={"checkmark-circle"} />} size={"16px"} color={color.palette.blueJalaBase}
            marginTop={"5px"}
          />
          <View flex={1} paddingLeft={"12px"}>
            <Text tx="gotoJalaProScreen.benefitTitle5" preset="title3" colorScheme={colorScheme} />
            <Text tx="gotoJalaProScreen.benefitDesc5" preset="body3" colorScheme={colorScheme} />
          </View>
        </View>
        <Text marginTop="13px" preset="body3" colorScheme={colorScheme}>{translate("gotoJalaProScreen.readMore")}
        <Text underline={true} color={color.palette.blue500} onPress={onPressInfo} preset="body3" tx="gotoJalaProScreen.urlJalaPro" /></Text>
      </ScrollView>
      <View
        bottom={0} left={0} right={0}
        position={"absolute"}
        paddingX="16px" paddingY="20px"
        backgroundColor={color.palette.white}
        shadow={"1px"}
      >
        <Button
          tx="gotoJalaProScreen.upgradeNow"
          onPress={onPressGotoPayment}
          colorScheme={colorScheme}
        />
      </View>
    </Screen>
  )
})
